import React from "react";
import "./video.css";
import styled from "styled-components";
import pbv1 from "./../../assets/movies/PoPBellYNFT_V1.webm"

const VideoSectionStyles = styled.aside`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 3rem 0;
  video {
    min-width: 150px;
    border: 5px solid white;
    border-radius: 15px;
  }
  @media (min-width: 800px){
   video {
    border: 1rem solid white;
     
   }
 }
`

const VideoSection = () => {

  return (
    <VideoSectionStyles>
      <video autoPlay muted controls loop>
        <source src={pbv1} type="video/mp4"/>
      </video>
    </VideoSectionStyles>

  );
};

export default VideoSection;